import { useState, useEffect } from "react";
import { Typography, Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getUserInvitesByHash } from "../../../api/userInviteService";
import RegistrationForm from "../../users/modals/RegistrationForm";
import { useNavigate } from "react-router-dom";
import { useDeleteUserInviteByHash } from "../../../hooks/users/useDeleteUserInviteByHash";
import ConfirmDialog from "../../common/modals/ConfirmDialog";

const UserInviteDisplay = ({hash}) => {
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

  const [data, setData] = useState(null);
  const [message, setMessage] = useState("");

  const onDeleteSuccess = () => {
    navigate("/login");
  };

  const { remove } = useDeleteUserInviteByHash(onDeleteSuccess);

  const onDeclineClick = async () => {
    await remove(hash);
  };

  const onLoginClick = () => {
    navigate("/login");
  };

  const onRegistrationSuccess = () => {
    setRegistrationSuccess(true);
  };
  
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [formOpen, setFormOpen] = useState(false);

  const fetchData = async () => {
    try {
      const data = await getUserInvitesByHash(hash);
      setData(data);
    } catch(error) {
      setMessage("Invalid invite request");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (registrationSuccess) {
    return (
      <>
        <Typography variant="h6">Account Activated!</Typography>
        <Typography variant="body1">
          Welcome to {' '}
          <Typography component="span" variant="body1" fontWeight="bold">
            Animora Vet Hub!
          </Typography>{' '}
        </Typography>
        <Typography variant="body1">Please login in now by clicking the button below.</Typography>
        <br />
        <Button 
          variant="outlined" 
          fullWidth
          onClick={() => onLoginClick()}
        >
          Login Now
        </Button>
      </>
    );
  }

  return (
    <>
      {!data ? 
      <Typography variant="body1" sx={{ flexGrow: 1, marginBottom: "1rem" }}>
        {message} 
      </Typography>
      :
      <>
        <Typography variant="h6">Invitation</Typography>
        <Typography variant="body1">
          You've been invited to join the{' '}
          <Typography component="span" variant="body1" fontWeight="bold">
            {data.office.name}
          </Typography>{' '}
          team as{' '}
          <Typography component="span" variant="body1" fontWeight="bold">
            {data.type}
          </Typography>
          {' '}user.
        </Typography>
        <br />
        <Button 
          variant="outlined" 
          fullWidth
          onClick={() => setFormOpen(true)}
        >
          Accept Invitation
        </Button>
        <br /><br />
        <Button 
          variant="text" 
          fullWidth
          onClick={() => setConfirmDialogOpen(true)}
        >
          Decline Invitation
        </Button>
      </>
      }
      {data ? 
      <RegistrationForm 
        successCallback={onRegistrationSuccess}
        open={formOpen}
        onClose={() => setFormOpen(false)}
        userInvite={data}
      />
      : null }
      <ConfirmDialog
        open={confirmDialogOpen}
        title="Decline Invitation"
        content="Are you sure you want to decline this invitation?"
        confirmText="Decline Invitation"
        cancelText="Cancel"
        onConfirm={onDeclineClick}
        onCancel={() => setConfirmDialogOpen(false)}
      />
    </>
  );
};

export default UserInviteDisplay;